module.exports = __webpack_public_path__ + "media/images/pic/workshops/pomaluj-moj-swiat-241d1906c86f21be45dd152c6ac000fe.jpeg";